import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';
import { z } from 'zod';
import { resetPassword } from '../auth/client.js';

const Schema = z.object({ password: z.string().min(12) });
type FormData = z.infer<typeof Schema>;

export function ResetPassword() {
  const { t } = useTranslation('auth');
  const [params] = useSearchParams();
  const token = params.get('token');
  const nav = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<FormData>({
    resolver: zodResolver(Schema),
  });
  const [error, setError] = useState<string | null>(null);

  const onSubmit = handleSubmit(async (data) => {
    if (!token) return;
    try {
      await resetPassword({ newPassword: data.password, token });
      nav('/login');
    } catch (e: unknown) {
      setError((e as Error).message);
    }
  });

  if (!token) {
    return <div className="m-8">Token inválido</div>;
  }

  return (
    <div className="mx-auto mt-16 max-w-sm rounded border bg-white p-6">
      <h1 className="mb-4 text-xl font-semibold">{t('resetPassword')}</h1>
      <form onSubmit={onSubmit} className="space-y-3">
        <input
          type="password"
          {...register('password')}
          placeholder={t('password')}
          className="w-full rounded border px-3 py-2"
        />
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full rounded bg-blue-600 py-2 text-white disabled:opacity-50"
        >
          {t('resetPassword')}
        </button>
      </form>
    </div>
  );
}
